import { productInfo } from "@/mocks/product";

export default function CTASection() {
  return (
    <section
      id="find-at-costco"
      className="relative w-full min-h-[500px] md:min-h-[600px] flex items-end"
    >
      <div className="absolute inset-0">
        <img
          src={productInfo.images.hero}
          alt="CTA background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-20 py-16 md:py-24">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <p className="text-xs text-white/60 tracking-widest uppercase mb-3">
              Item #{productInfo.itemNumber}
            </p>
            <h2
              className="text-3xl md:text-5xl lg:text-6xl font-semibold text-white leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Pour Your Cat
              <br />
              A Fine Bottle
            </h2>

            <a
              href="https://www.costco.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 mt-8 px-6 py-3.5 bg-white text-stone-900 text-sm font-semibold rounded-full hover:bg-stone-100 transition-colors whitespace-nowrap"
            >
              Find at Your Local Costco
              <span className="w-7 h-7 rounded-full bg-stone-900 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-xs" />
              </span>
            </a>
          </div>

          <div className="md:text-right md:max-w-sm">
            <p className="text-sm md:text-base text-white/80 leading-relaxed">
              Available exclusively at Costco warehouses
              <br />
              Natural jute rope · Sturdy wood base
              <br />
              Cabernet Red and Merlot Brown
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}